import { useEffect } from 'react';
import { useHotkeysContext } from 'react-hotkeys-hook';
import useStaticHandler from '../useStaticHandler/useStaticHandler.js';

// This hook enables and disbles a key scope passed as an argument

// Automatically activates the 'hotkeys' referents to 'scope' when the user pointerdown
// inside the focused 'ref' node element or its children
const useHotKeyScope = (ref, scope) => {
  const {
    enableScope,
    disableScope,
    enabledScopes
  } = useHotkeysContext();
  const onPointerDown = useStaticHandler(event => {
    const target = event.target;
    const isFocused = ref.current?.contains(target);
    if (isFocused) {
      enabledScopes.forEach(enabledScope => disableScope(enabledScope));
      enableScope(scope);
    } else {
      disableScope(scope);
    }
  });
  useEffect(() => {
    window.addEventListener('pointerdown', onPointerDown);
    // Cleanup function to remove listener on unmount
    return () => window.removeEventListener('pointerdown', onPointerDown);
  }, [onPointerDown]);
};
var useHotKeyScope$1 = useHotKeyScope;

export { useHotKeyScope$1 as default };
//# sourceMappingURL=useHotKeyScope.js.map
